export const Urls = {
  login: () => "/user/authenticate",

  //get
  doctorGet: () => "/doctor/get",
  areaGet: () => "/area/get",
  leaveGet: () => "/leave_type/get",
  labGet: () => "/lab/get",
  faqGet: () => "/faq/get",
  reviewGet: () => "/get/doctor/review",
  helpGet: () => "/help/get",
  consultGet: () => "/consult_master/get",
  appointmentGet: () => "/appointment/get",
  doctorAvailabilityGet: () => "/doctor_availability/get",
  profileGet: () => "/user_master/get",
  doctorHolidayGet: () => "/doctor_holiday/get",
  patientGet: () => "/patient/get",
  UserMasterGet: () => "/user/get",
  doctorSlotBlockGet: () => "/doctor_slot_block/get",
  doctorSlotBlockGetById: () => "/doctor_slot_block/get_by_id",

  //add
  imageAdd: () => "/upload_image",
  helpAdd: () => "/help/insert",
  consultAdd: () => "/consult_master/add",
  doctorAdd: () => "/doctor/add",
  areaAdd: () => "/area/add",
  labAdd: () => "/lab/add",
  faqAdd: () => "/faq/insert",
  labtestReportAdd: () => "/appointment_lab_test_reports/add",
  doctorAvailabilityAdd: () => "/doctor_availability/insert",
  labTestAdd: () => "/appointment_lab_test/add",
  doctorHolidayAdd: () => "/doctor_holiday/add",
  leaveAdd: () => "/leave_type/add",
  UserMasterAdd: () => "/user/add",
  doctorSlotBlockAdd: () => "/doctor_slot_block/insert_update",

  //update
  doctorUpdate: () => "/doctor/update",
  areaUpdate: () => "/area/update",
  appointmentUpdate: () => "/appointment/update",
  labUpdate: () => "/lab/update",
  consultUpdate: () => "/consult_master/update",
  faqUpdate: () => "/faq/update",
  doctorAvailabilityUpdate: () => "/doctor_availability/update",
  helpUpdate: () => "/help/update",
  labTestUpdate: () => "/appointment_lab_test_reports/update",
  testUpdate: () => "/appointment_lab_test/update",
  doctorHolidayUpdate: () => "/doctor_holiday/update",
  leaveUpdate: () => "/leave_type/update",
  UserMasterUpdate: () => "/user/update",
  //combo
  getDoctorCombo: () => "/doctor/get/combo",
  getAreaCombo: () => "/area_combo/get",
  getConsultCombo: () => "/consult_combo/get",
  getPatientCombo: () => "/patient_combo/get",
  getLeaveCombo: () => "/leave_type_combo_get",
  getWeekDayCombo: () => "/week_days_doctor_availability/get/combo",
  //getdata by id

  getConsultDatabyId: () => "/consult_by_id/get",
  getDoctorAvailabilityById: () => "/doctor_availability_by_id/get",
  getFaqById: () => "/faq_by_id/get",
  getHelpById: () => "/help_by_id/get",
  getLeaveById: () => "/leave_type_get_by_id",
  getDoctorDatabyId: () => "/doctor_by_id/get",
  getlabDatabyId: () => "/lab_by_id/get",
  getDoctorAppointmentSlots: () => "/appointment_slots/doctor/get",
  getareaDatabyId: () => "/area_by_id/get",
  getappointmentDatabyId: () => "/appointment_by_id/get",
  getHolidaybyId: () => "/doctor_holiday_get_by_id",
  getUserMasterDatabyId: () => "/user/get_by_id",
  getReviewById: () => "/get/doctor/review_by_id",
  updateReview: () => "/update/doctor/review",
  doctorSlotBlockDelete: () => "/doctor_slot_block/delete",
};

export const color = {
  button: "#465BF2",
  bodyBackground: "#edf3ff",
  forgetpassText: "#A5BECC",
  pinkText: "#FC4B6F",
};
